import { API_ENDPOINTS } from "../../../Api/apiEndPoints"
import axiosInstance from "../../../Api/axiosInstance"

// export const getEmployeeReport = async(param:any)=>{
//     console.log('param',param);

//     let response = await axiosInstance.get(API_ENDPOINTS.Reports.GET_EMPLOYEE_REPORT,{params:param});
//     const rowData = await response?.data;


//     const formatedData = Array.isArray(rowData.data.EmployeeReportData)?
//       rowData.data.EmployeeReportData.map((item:any)=>({
//         EmployeeCode:item.EmployeeCode,
//         FullName:item.FullName,
//          StartTime:item.StartTime,
//          EndTime:item.EndTime,
//          OutletCount:item.OutletCount,
//          Status:item.Status,
//          AttendanceDate:item.AttendanceDate,
//          AttendanceId:item.AttendanceId
//       }))
//     :[]
//     return {rowData,formatedData};
// }


export const getEmployeeReport = async (param: any) => {
      const response = await axiosInstance.get(API_ENDPOINTS.Reports.GET_EMPLOYEE_REPORT,{ params: param });
      const rowData = response?.data;

      const formatedData = Array.isArray(rowData?.data?.EmployeeReportData)
        ? rowData.data.EmployeeReportData.map((item: any) => ({
            EmployeeCode: item.EmployeeCode,
            FullName: item.FullName,
            StartTime: item.StartTime,
            EndTime: item.EndTime,
            OutletCount: item.OutletCount,
            Status: item.Status,
            AttendanceDate: item.AttendanceDate,
            AttendanceId: item.AttendanceId,
          }))
        : [];

     return { rowData, formatedData };
};









export const getEmployeeVisit = async(attendanceId:number)=>{
    let response = await axiosInstance.get(API_ENDPOINTS.Reports.GET_EMPOLYEE_VISITS,{params:{attendanceId}},);
    const rowData = response?.data;
    return {rowData,}
  }

export const getMonthYearFilter = async()=>{
   let response = await axiosInstance.get(API_ENDPOINTS.Reports.GET_MONTH_YEAR_FILTER);
   const rowData =  await response.data;   
   const formatedData = [{id:null ,label:'All'}, ...Object.entries(rowData?.data?.MonthYear || {}).map(([key,value])=>({
    id:key,
    label:value
   }))]
   
   return {rowData,formatedData};
}


